<!-- confirmation.component.html -->
<div class="modal-header">
  <h5 class="modal-title alert">
    {{ (confirmationType === 'attach_genlink' || confirmationType === 'change_made' || confirmationType === 'delete_document') ? 'Confirmation' : 'Alert' }}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <div class="upload-container">
    {{ confirmationMessage }}
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn"
    [class.btn-success]="isDeleteFlow"
    [class.btn-danger]="!isDeleteFlow"
    (click)="cancel()">No</button>
  <button type="button" class="btn"
    [class.btn-danger]="isDeleteFlow"
    [class.btn-success]="!isDeleteFlow"
    (click)="confirm()">Yes</button>
</div>